import React from 'react';
import { DeliveryStatus } from '../components/DeliveryStatus';
import { PageHeader } from '../components/PageHeader';
import { Panel } from '../components/Panel';
import { WeekBoard } from '../components/WeekBoard';
export function CalendarView() {
  return <div data-id="element-166" data-mp="1dwvn0v2tycvv">
      <PageHeader eyebrow="125 anchor slots" title="Weekly calendar" description="Each card is a briefed, date-specific piece of content, coloured by how close it is to its publish date. Tick one off and it stays in place, greyed out, so the week still reads as a whole." data-id="element-167" data-mp="1dx56s0xa7nt4" />

      <Panel eyebrow="Progress" title="Delivery status" className="mb-5" data-id="element-168" data-mp="v4b0rwhmz611">
        <DeliveryStatus showReset data-id="element-169" data-mp="v6dzd4wuu7hd" />
      </Panel>

      <WeekBoard data-id="element-170" data-mp="103nw75mkplf8" />
    </div>;
}